import { createIcon } from '../createIcon';
export const MinusIcon = createIcon({
  viewBox: '0 0 24 24',
  d: 'M22 10.5H2V13H22V10.5Z'
});
//# sourceMappingURL=Minus.js.map